@if (data && data.TrainingType != null && data.TrainingType != ProtectedFieldValueType.SkillQualificationNone_None) {
    <!-- Only render if Qualification OR Skill typed -->
<div class="rounded-b bg-form shadow-md">
    <div class="h-2 w-full rounded-t bg-blue-500">
    </div>
    <div class="mx-4 my-2 flex items-center gap-2 rounded-t text-blue-500">
        <bizz-icon class="h-4 w-4" iconName="user-check"></bizz-icon>
        <span class="text-lg font-bold">{{ "TrainingAssessment" | translate }}</span>
    </div>
    <div class="mx-4 flex flex-col">
        <hr class="hidden sm:flex">
        @if(data.Participants.length > 1) {
            <div class="mt-3 flex items-center justify-between">
                <span class="font-semibold text-default">{{ "Participants" | translate }}</span>
                @if(data.TrainingType != ProtectedFieldValueType.SkillQualificationNone_Qualification){
                    <button class="blue h-9 w-max grow-0" (click)="openSetAllGradesModal()">{{'EditAll' | translate}}</button>
                }
            </div>
            @if(data.TrainingType == ProtectedFieldValueType.SkillQualificationNone_Qualification){
                <div class="mt-3 flex items-center justify-end gap-5">
                    @if(documentTemplate != undefined && documentTemplate.DefaultTemplate != null && documentTemplate.DefaultTemplate.Templates != null && documentTemplate.DefaultTemplate.Templates.length > 0) {
                        <button class="default h-9 w-max grow-0" (click)="createCertificate()"><span><bizz-icon class="h-4 w-4" iconName="file-medical"></bizz-icon> {{'CreateCertificate' | translate}}</span></button>
                    }
                    <button class="default h-9 w-max grow-0" (click)="toggleAbsentees()">
                        <span><bizz-icon class="h-4 w-4" [iconName]="showAbsentees ? 'eye-slash' : 'eye'"></bizz-icon>
                            {{ ( showAbsentees ? 'Hide' : 'Show') | translate}} {{'Absentees' | translate}}</span>
                    </button>
                </div>
            }
        }
        <div class="my-2 flex flex-col gap-2 overflow-auto sm:my-4 sm:flex-row sm:gap-0">
            <kendo-grid [data]="applyFilter(data.Participants)" [resizable]="true" class="min-w-full" #trainingAssessmentKendoGrid [trackBy]="trackBy">
                <kendo-grid-column [width]="200" [minResizableWidth]="200">
                    <ng-template kendoGridHeaderTemplate let-dataItem>
                        <b>{{ "Participant" | translate }}</b>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <b class="text-xs">{{ dataItem.Name }}</b>
                    </ng-template>
                </kendo-grid-column>

                <kendo-grid-column [width]="70" [minResizableWidth]="70">
                    <ng-template kendoGridHeaderTemplate>
                        <b>{{ "Present" | translate }}</b>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <input type="checkbox" (ngModelChange)="presentChanged(dataItem, $event)" [disabled]="readonly" kendoCheckBox
                            [(ngModel)]="dataItem.Present">
                    </ng-template>
                </kendo-grid-column>

                @if(data.TrainingType == ProtectedFieldValueType.SkillQualificationNone_Skill) {
                <kendo-grid-column [width]="120" [minResizableWidth]="120">
                    <ng-template kendoGridHeaderTemplate let-dataItem>
                        <b>{{ "CurrentGrade" | translate }}</b>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem>
                        @if (dataItem.OldUserSkillGrade && getScore(dataItem.OldUserSkillGrade, false); as skillGrade) {
                        <kendo-circulargauge [value]="skillGrade.Score" [scale]="{ max: 100 }" [colors]="colors"
                            class="size-14">
                            <kendo-arcgauge-scale [rangeSize]="5">
                                <ng-template kendoCircularGaugeCenterTemplate let-value="value">
                                    <span class="text-xs">

                                        @if (dataItem.OldUserSkillGrade.Expiracy == null) {
                                        {{ skillGrade.Score }}<span class="text-xxs">%</span>
                                        } @else {
                                        @switch (dataItem.OldUserSkillGrade.Expiracy.ExpiracyStatus) {
                                        @case (ExpiracyStatus.NotExpired) {
                                        {{ skillGrade.Score }}<span class="text-xxs">%</span>
                                        }
                                        @case (ExpiracyStatus.AlmostExpired) {
                                        <bizz-icon class="size-3 text-yellow-500"
                                            iconName="circle-exclamation"></bizz-icon>
                                        }
                                        @case (ExpiracyStatus.Expired) {
                                        <bizz-icon class="size-3 text-red-500" iconName="xmark"></bizz-icon>
                                        }
                                        @case (ExpiracyStatus.ExpirationPrediction) {
                                        <bizz-icon class="size-3 text-red-500" iconName="xmark"></bizz-icon>
                                        }
                                        }
                                        }

                                    </span>
                                </ng-template>
                            </kendo-arcgauge-scale>
                        </kendo-circulargauge>

                        }
                    </ng-template>
                </kendo-grid-column>


                <kendo-grid-column [width]="180" [minResizableWidth]="180">
                    <ng-template kendoGridHeaderTemplate let-dataItem>
                        <b>{{ "SetSkillGradeFor" | translate }} '{{ data.Skill.Text }}'</b>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem>
                        @if (dataItem.Present) {
                        <div class="w-4/6">
                            <bizz-form-trainingapp-assessment-slider class="w-4/6" [value]="dataItem.NewUserSkillGrade"
                                (valueChanged)="onSkillChanged($event,dataItem)"
                                [skillGrades]="data.SkillGrades"></bizz-form-trainingapp-assessment-slider>
                        </div>

                        } @else {
                        <div class="flex items-center gap-2 text-xs">
                            <input type="checkbox" kendoCheckBox (ngModelChange)="emitUpdate()" [disabled]="readonly"
                                [(ngModel)]="dataItem.AddToTrainingsQueue"> {{ "AddUserAgainToQueue" | translate }}.
                        </div>

                        }
                    </ng-template>
                </kendo-grid-column>

                <kendo-grid-column [width]="90" [minResizableWidth]="90">
                    <ng-template kendoGridHeaderTemplate let-dataItem>
                        <b>{{ "NewGrade" | translate }}</b>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem>
                        @if (dataItem.Present && getScore(dataItem.NewUserSkillGrade, true); as skillGrade) {

                        <kendo-circulargauge [value]="skillGrade.Score" [scale]="{ max: 100 }" [colors]="colors"
                            class="size-14">
                            <kendo-arcgauge-scale [rangeSize]="5">
                                <ng-template kendoCircularGaugeCenterTemplate let-value="value">
                                    <span class="text-xs">
                                        @if (dataItem.OldUserSkillGrade?.Expiracy == null) {
                                        {{ skillGrade.Score }}<span class="text-xxs">%</span>
                                        } @else {
                                        @switch (dataItem.OldUserSkillGrade.Expiracy.ExpiracyStatus) {
                                        @case (ExpiracyStatus.NotExpired) {
                                        {{ skillGrade.Score }}<span class="text-xxs">%</span>
                                        }
                                        @case (ExpiracyStatus.AlmostExpired) {
                                        <bizz-icon class="size-3 text-yellow-500"
                                            iconName="circle-exclamation"></bizz-icon>
                                        }
                                        @case (ExpiracyStatus.Expired) {
                                        <bizz-icon class="size-3 text-red-500" iconName="xmark"></bizz-icon>
                                        }
                                        @case (ExpiracyStatus.ExpirationPrediction) {
                                        <bizz-icon class="size-3 text-red-500" iconName="xmark"></bizz-icon>
                                        }
                                        }
                                        }

                                    </span>
                                </ng-template>
                            </kendo-arcgauge-scale>
                        </kendo-circulargauge>

                        }
                    </ng-template>
                </kendo-grid-column>

                }
                @if(data.TrainingType == ProtectedFieldValueType.SkillQualificationNone_Qualification) {
                    <kendo-grid-column [width]="155" [minResizableWidth]="155">
                        <ng-template kendoGridHeaderTemplate let-dataItem>
                            <b>{{ "CurrentQualification" | translate }}</b>
                        </ng-template>
                        <ng-template kendoGridCellTemplate let-dataItem>
                            @if(dataItem.QualificationInfinite == true) {
                            {{ "Infinite" | translate }}
                            } @else {
                            {{ dataItem.CurrentQualificationExpiry | date }}
                            }
                        </ng-template>
                    </kendo-grid-column>

                    <kendo-grid-column [width]="70" [minResizableWidth]="70">
                        <ng-template kendoGridHeaderTemplate let-dataItem>
                            <b>{{ "Achieved" | translate }}</b>
                        </ng-template>
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <input type="checkbox" (ngModelChange)="achievedChanged(dataItem,$event)" [disabled]="readonly || !dataItem.Present" kendoCheckBox
                                   [(ngModel)]="dataItem.QualificationAchieved">
                        </ng-template>
                    </kendo-grid-column>

                    <kendo-grid-column [width]="155" [minResizableWidth]="155">
                        <ng-template kendoGridHeaderTemplate let-dataItem>
                            <b>{{ "NewQualification" | translate }}</b>
                        </ng-template>
                        <ng-template kendoGridCellTemplate let-dataItem>
                            {{ data.NewCertificateStartDate | date }}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column [width]="234" [minResizableWidth]="234">
                        <ng-template kendoGridHeaderTemplate let-dataItem>
                            <b>{{ "Certificate" | translate }}</b>
                        </ng-template>
                        <ng-template kendoGridCellTemplate let-dataItem>
                            @if(!dataItem.Present || !dataItem.QualificationAchieved) {
                            <div class="flex items-center gap-2 text-xs">
                                <input type="checkbox" kendoCheckBox (ngModelChange)="dataItem.Certificate = undefined;emitUpdate()" [disabled]="readonly"
                                       [(ngModel)]="dataItem.AddToTrainingsQueue"> {{ "AddUserAgainToQueue" | translate }}.
                            </div>
                            } @else {
                                @if (dataItem.Present && dataItem.QualificationAchieved && templateInfo) {
                                    <bizz-file-upload
                                            [initFile]="dataItem.mediaCommitDto"
                                            [minified]="true"
                                            [excludeCopyTo]="true"
                                            [documentTemplate]="templateInfo"
                                            (fileChanged)="fileChanged(dataItem,$event)">
                                    </bizz-file-upload>
                                }
                            }
                        </ng-template>
                    </kendo-grid-column>
                }
                <kendo-grid-column [width]="400">
                    <ng-template kendoGridHeaderTemplate let-dataItem>
                        <b>{{ "Remarks" | translate }}</b>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <textarea
                            class="form-control w-full rounded border border-form-control bg-form-control bg-none text-sm text-widget p-[0.5rem]"
                            rows="1" (ngModelChange)="emitUpdate()" [(ngModel)]="dataItem.Remarks"
                            [disabled]="!dataItem.Present || readonly"></textarea>
                    </ng-template>
                </kendo-grid-column>

            </kendo-grid>
        </div>
    </div>
</div>

}